import React, { useState } from "react"
import { BrowserRouter as Router, Route, Routes } from "react-router-dom"
import { Navigate } from "react-router-dom"
import toast, { Toaster } from "react-hot-toast"
import { toastStyle } from "./Helpers/Utils/Common"

import { getToken, getType } from "./Helpers/Utils/Common"
import {
  logoutUser,
  logoutUserPotato,
  checkTokenStatus,
} from "./Helpers/apiCalls/authApi"
import { removeUserSession } from "./Helpers/Utils/Common"

import "./Components/FontAwesomeIcons"
import "./Assets/Images/FontAwesomeIcons"
import "./App.css"

/** PAGES **/

/**
 * -- LOGIN SCREEN
 */
import Login from "./Pages/Login/Login"

/**
 * -- DASHBOARD
 */
import Dashboard4 from "./Pages/Dashboard/Dashboard4"

/**
 * -- FRANCHISE
 */
import Franchise from "./Pages/Franchise/Franchise"

// Franchise Sales Invoice
import FormFranchiseInvoice from "./Pages/Franchise/FormFranchiseInvoice"
import SuppliesExpenses from "./Pages/Expenses/SuppliesExpenses/SuppliesExpenses"
import FormSuppliesExpenses from "./Pages/Expenses/SuppliesExpenses/Components/FormSuppliesExpenses"
import ReviewSuppliesExpense from "./Pages/Expenses/SuppliesExpenses/Components/ReviewSuppliesExpense"
import FormPaySupplier from "./Pages/Purchases/Pay Suppliers/Components/FormPaySupplier"
import PrintSuppliesExpense from "./Pages/Expenses/SuppliesExpenses/Components/PrintSuppliesExpense"
import SalesInvoice from "./Pages/Sales/SalesInvoice"
import FormSalesInvoice from "./Pages/Sales/FormSalesInvoice"

// Franchise Sales Invoice
import FranchiseSalesReport from "./Pages/Franchise/FranchiseSalesReport"

// Monthly Sales Billing
import FranchiseBilling from "./Pages/Franchise/FranchiseBilling/FranchiseBilling"
import FranchiseBillingForm from "./Pages/Franchise/FranchiseBilling/FranchiseBillingForm"
import FranchiseBillingView from "./Pages/Franchise/FranchiseBilling/FranchiseBillingView"

// Receivables
import Receivables from "./Pages/Franchise/Receivables/Receivables"
import PrintReceivable from "./Pages/Franchise/Receivables/PrintReceivable"
import PrintSalesInvoice from "./Pages/Sales/PrintSalesInvoice"
import PrintFranchiseInvoice from "./Pages/Franchise/PrintFranchiseInvoice"

// Franchisee Payments
import Payments from "./Pages/Franchise/Payments/Payments"
import PaymentsPrint from "./Pages/Franchise/Payments/PrintPayments"

/**
 * -- PURCHASES
 */

// Purchase Request
import PurchaseRequest from "./Pages/Purchases/PurchaseRequest/PurchaseRequest"
import AddPurchaseRequest from "./Pages/Purchases/PurchaseRequest/Components/AddPurchaseRequest"
import EditPurchaseRequest from "./Pages/Purchases/PurchaseRequest/Components/EditPurchaseRequest"
import ReviewPurchaseRequest from "./Pages/Purchases/PurchaseRequest/Components/ReviewPurchaseRequest"
import ViewPurchaseRequest from "./Pages/Purchases/PurchaseRequest/Components/ViewPurchaseRequest"

// Purchase Orders
import PurchaseOrders from "./Pages/Purchases/PurchaseOrders/PurchaseOrders"
import AddPurchaseOrder from "./Pages/Purchases/PurchaseOrders/Components/AddPurchaseOrder"
import EditPurchaseOrder from "./Pages/Purchases/PurchaseOrders/Components/EditPurchaseOrder"
import PrintPurchaseOrder from "./Pages/Purchases/PurchaseOrders/Components/PrintPurchaseOrder"
import ReviewPurchaseOrder from "./Pages/Purchases/PurchaseOrders/Components/ReviewPurchaseOrder"

// Purchase Invoice
import PurchaseInvoices from "./Pages/Purchases/Purchase Invoice/PurchaseInvoices"
import FormPurchaseInvoice from "./Pages/Purchases/Purchase Invoice/Components/FormPurchaseInvoice"
import PrintPurchaseInvoice from "./Pages/Purchases/Purchase Invoice/Components/PrintPurchaseInvoice"
import PayPurchaseInvoice from "./Pages/Purchases/Purchase Invoice/Components/PayPurchaseInvoice"
import PurchaseReturn from "./Pages/Purchases/PurchaseReturn/PurchaseReturn"
import PurchaseReturnForm from "./Pages/Purchases/PurchaseReturn/PurchaseReturnForm"
import PrintPurchaseReturn from "./Pages/Purchases/PurchaseReturn/ViewPurchaseReturn"

// Pay Supplier
import ViewPaySupplier from "./Pages/Purchases/Pay Suppliers/Components/ViewPaySupplier"
import PaySuppliers from "./Pages/Purchases/Pay Suppliers/PaySuppliers"
import ViewInvoice from "./Pages/Purchases/Pay Suppliers/Components/ViewInvoice"

// Issued Payments
import PurchaseIssuedPayment from "./Pages/Purchases/PurchaseIssuedPayment/PurchaseIssuedPayment"
/**
 * -- SUPPLIES
 */

// Purchase Orders
import PO from "./Pages/Expenses/PurchaseOrders/PurchaseOrders"
import AddPO from "./Pages/Expenses/PurchaseOrders/Components/AddPurchaseOrder"
import EditPO from "./Pages/Expenses/PurchaseOrders/Components/EditPurchaseOrder"
import PrintPO from "./Pages/Expenses/PurchaseOrders/Components/PrintPurchaseOrder"
import ReviewPO from "./Pages/Expenses/PurchaseOrders/Components/ReviewPurchaseOrder"
import SEFormPurchaseInvoice from "./Pages/Expenses/Purchase Invoice/Components/SEFormPurchaseInvoice"

// Purchase Invoice
import PrintPI from "./Pages/Expenses/Purchase Invoice/Components/PrintPurchaseInvoice"
import PayPI from "./Pages/Expenses/Purchase Invoice/Components/PayPurchaseInvoice"
import PI from "./Pages/Expenses/Purchase Invoice/PurchaseInvoices"

// Pay Suppliers
import ViewPaySupplierE from "./Pages/Expenses/Pay Suppliers/Components/ViewPaySupplier"
import PaySuppliersE from "./Pages/Expenses/Pay Suppliers/PaySuppliers"
import FormPaySupplierE from "./Pages/Expenses/Pay Suppliers/Components/FormPaySupplier"
import ViewInvoiceSe from "./Pages/Expenses/Pay Suppliers/Components/ViewInvoice"

/**
 * -- INVENTORY
 */
import ItemLists from "./Pages/Inventory/ItemLists"
import LowOnStock from "./Pages/Inventory/LowOnStock"
import BranchAdjustment from "./Pages/Inventory/ItemList/BranchAdjustment"
import ItemHistory from "./Pages/Inventory/ItemList/ItemHistory"
import ItemHistorySearch from "./Pages/Inventory/ItemList/ItemHistorySearch"
import ItemDetails2 from "./Pages/Inventory/ItemList/ItemDetails2"
import Requests from "./Pages/Inventory/Requests"
import ViewRequests from "./Pages/Inventory/Requests/ViewRequest"
import Transfers from "./Pages/Inventory/Transfers"
import IncomingTransfers from "./Pages/Inventory/IncomingTransfers"
import ViewTransfer from "./Pages/Inventory/ViewTransfer"
import ReviewTransfer from "./Pages/Inventory/ReviewTransfer"
import FormTransfer from "./Pages/Inventory/FormTransfer"
import FormReceiveTransfer from "./Pages/Inventory/FormReceiveTransfer"
import ViewTransferReceive from "./Pages/Inventory/ViewTransferReceive"
import BranchInventory from "./Pages/Inventory/BranchInventory"
// import ItemHistoryFilter from "./Pages/Inventory/ItemHistory";
import Adjustments from "./Pages/Inventory/Adjustments"
import StoreAdjustments from "./Pages/Inventory/StoreAdjustments"
import ViewAdjustment from "./Pages/Inventory/Adjustment/ViewAdjustment"

/**
 * -- REPORTS
 */
import CustomerPaymentsReports from "./Pages/Reports/CustomerPaymentReports/CustomerPaymentReports"
import DailyAttendanceList from "./Pages/Reports/DailyAttendanceList/DailyAttendanceList"
import DailyCashCounts from "./Pages/Reports/DailyCashCounts/DailyCashCounts"
import DailyExpenses from "./Pages/Reports/DailyExpenses/DailyExpenses"
import DailyWastage from "./Pages/Reports/DailyWastage/DailyWastage"
import DailySales from "./Pages/Reports/DailySales/DailySales"
import DailyOrders from "./Pages/Reports/DailyOrders/DailyOrders"
import PrintDailySales from "./Pages/Reports/DailySales/PrintDailySales"
import EmployeeDeductions from "./Pages/Reports/DailySales/EmployeeDeductions"
import WastageReports from "./Pages/Reports/WastageReports/WastageReports"
import StoreDeposit from "./Pages/Reports/StoreDeposit/StoreDeposit"

/**
 * -- REPORTS VIEw
 */
import ViewDailyCashCount from "./Pages/Reports/DailyCashCounts/ViewDailyCashCount"
import ViewDailyExpenses from "./Pages/Reports/DailyExpenses/ViewDailyExpenses"
import PrintDailyExpenses from "./Pages/Reports/DailyExpenses/PrintDailyExpenses"
import ViewDailyWastage from "./Pages/Reports/DailyWastage/ViewDailyWastage"
import ViewDailyAttendanceList from "./Pages/Reports/DailyAttendanceList/ViewDailyAttendanceList"
import EmployeeHours from "./Pages/Reports/DailyAttendanceList/EmployeeHours"
import BranchDailyOrders from "./Pages/Reports/DailyOrders/BranchDailyOrders"
import AddOrder from "./Pages/Reports/DailyOrders/AddOrder"
import ViewDailySales from "./Pages/Reports/DailySales/ViewDailySales"
import DailyUsage from "./Pages/Reports/DailyUsage/DailyUsage"

/**
 * -- OFFICE REPORTS
 */
import Payables from "./Pages/OfficeReports/Payables"
import TotalSales from "./Pages/OfficeReports/TotalSales/TotalSales"
import FranchiseeSalesReport from "./Pages/OfficeReports/FranchiseeSalesReport/FranchiseeSalesReport"
import SalesByItem from "./Pages/OfficeReports/SalesByItem/SalesByItem"
import ListOfStores from "./Pages/OfficeReports/Stores"
import ListOfBranches from "./Pages/Reports/BranchList/BranchList"
import PurchasedItemsSummary from "./Pages/OfficeReports/PurchasedItemsSummary/PurchasedItemsSummary"
import TransferHistory from "./Pages/OfficeReports/TransferHistory/TransferHistory"
import ViewTransferHistory from "./Pages/OfficeReports/TransferHistory/ViewTransferHistory"
import SalesPerProduct from "./Pages/Reports/SalesPerProduct/SalesPerProduct"

/**
 * -- MANAGE
 */

// Category
import Category from "./Pages/Manage/Category"
import FormCategory from "./Pages/Manage/Category/FormCategory"

// Suppliers
import Suppliers from "./Pages/Manage/Suppliers"

// Banks
import Banks from "./Pages/Manage/Banks"

// Branches
import Branches from "./Pages/Manage/Branches"
import Warehouses from "./Pages/Manage/Warehouses"

// Items
import Items from "./Pages/Manage/Items"

// Discounts
import Discounts from "./Pages/Manage/Discounts/Discounts"
import FormDiscounts from "./Pages/Manage/Discounts/FormDiscounts"
import ViewDiscounts from "./Pages/Manage/Discounts/ViewDiscounts"

// Products
import Products from "./Pages/Manage/Products"

// Products
import ItemPrices from "./Pages/Manage/ItemPrices/ItemPrices"

//DSR Items
import DsrItems from "./Pages/Manage/DsrItems/DsrItems"

// Price Levels
import PriceLevels from "./Pages/Manage/PriceLevels"
import AddPriceLevel from "./Pages/Manage/Components/AddPL"
import EditPriceLevel from "./Pages/Manage/Components/EditPL"
import ViewPriceLevel from "./Pages/Manage/Components/ViewPL"

// Users
import Users from "./Pages/Manage/Users"

// Employees
import Employees from "./Pages/Manage/Employees"
import CashAdvance from "./Pages/Employees/CashAdvance/CashAdvance"
import FormCashAdvance from "./Pages/Employees/CashAdvance/FormCashAdvance"
import ReviewCashAdvance from "./Pages/Employees/CashAdvance/ReviewCashAdvance"
import Payroll from "./Pages/Employees/Payroll/Payroll"
import FormPayroll from "./Pages/Employees/Payroll/FormPayroll"
import ViewPayroll from "./Pages/Employees/Payroll/ViewPayroll"

// Forwarders
import Forwarders from "./Pages/Manage/Forwarders"

// GATE PASS
import GatePassForm from "./Pages/Inventory/GatePass/GatePassForm"
import GatePass from "./Pages/Inventory/GatePass/GatePass"
import GatePassView from "./Pages/Inventory/GatePass/GatePassView"

// PettyCash
import PettyCash from "./Pages/PettyCash/PettyCash"
import PettyCashCashInForm from "./Pages/PettyCash/PettyCashCashInForm"
import PettyCashCashInView from "./Pages/PettyCash/PettyCashCashInView"
import PettyCashCashOutForm from "./Pages/PettyCash/PettyCashCashOutForm"
import PettyCashCashOutView from "./Pages/PettyCash/PettyCashCashOutView"
import StoreDiscountReport from "./Pages/Reports/StoreDiscountReport/StoreDiscountReport"
import ProductPriority from "./Pages/Manage/ProductPriority"
import PeakHours from "./Pages/Reports/PeakHours/PeakHours"
import TotalSalesReport from "./Pages/Reports/TotalSalesReport/TotalSalesReport"
import MultiplePaymentsView from "./Pages/Franchise/Payments/MultiplePaymentsView"
import PayrollReport from "./Pages/Employees/Payroll/PayrollReport"
import EmployeeScheduler from "./Pages/Employees/EmployeeScheduler/EmployeeScheduler"
import UploadSchedule from "./Pages/Employees/EmployeeScheduler/UploadSchedule"
import FormSchedule from "./Pages/Employees/EmployeeScheduler/FormSchedule"
import MultiplePayroll from "./Pages/Employees/Payroll/MultiplePayroll"
import MultipleFormPayroll from "./Pages/Employees/Payroll/MultipleFormPayroll"
import UndertimeReport from "./Pages/Employees/SchedulerReport/UndertimeReport"
import UnfollowedBreakReport from "./Pages/Employees/SchedulerReport/UnfollowedBreakReport"
import Holiday from "./Pages/Employees/Holiday/Holiday"
import OvertimeReport from "./Pages/Employees/OvertimeReport/OvertimeReport"
import PurchaseReplacement from "./Pages/Purchases/PurchaseReplacement/PurchaseReplacement"
import PurchaseReplacementForm from "./Pages/Purchases/PurchaseReplacement/PurchaseReplacementForm"
import PayablesAgingReport from "./Pages/ExpensesReport/PayablesAgingReport/PayablesAgingReport"
import ExpenseByType from "./Pages/ExpensesReport/ExpenseByType/ExpenseByType"
import ExpenseByDate from "./Pages/ExpensesReport/ExpenseByDate/ExpenseByDate"
import ExpenseRegister from "./Pages/Expenses/ExpensesRegister/ExpensesRegister"
import TransferReceive from "./Pages/Inventory/TransferReceive/TransferReceive"
import RequestForm from "./Pages/Inventory/Requests/RequestForm"
import BuildItem from "./Pages/Manage/BuildItem"
import BuildItemView from "./Pages/Manage/BuildItemView"
import BuildItemForm from "./Pages/Manage/BuildItemForm"
import Departments from "./Pages/Manage/Departments/Departments"

// SALES QUOTATION
import SalesQuotation from "./Pages/SalesModules/SalesQuotation/SalesQuotation"
import SalesQuotationForm from "./Pages/SalesModules/SalesQuotation/SalesQuotationForm"
import SalesQuotationPrint from "./Pages/SalesModules/SalesQuotation/SalesQuotationPrint"

// SALES ORDER
import SalesOrder from "./Pages/SalesModules/SalesOrder/SalesOrder"
import SalesOrderForm from "./Pages/SalesModules/SalesOrder/SalesOrderForm"

// CUSTOMERS
import Customers from "./Pages/Manage/Customers/Customers"
import SalesOrderPrint from "./Pages/SalesModules/SalesOrder/SalesOrderPrint"
import ViewPurchaseReplacement from "./Pages/Purchases/PurchaseReplacement/ViewPurchaseReplacement"

// SALES PAYMENTS
import SalesPayments from "./Pages/SalesModules/SalesPayment/SalesPayment"
import SalesPaymentForm from "./Pages/SalesModules/SalesPayment/SalesPaymentForm"
import SalesPaymentView from "./Pages/SalesModules/SalesPayment/SalesPaymentView"
import ReceivablesAgingReport from "./Pages/Reports/ReceivablesAgingReport/ReceivablesAgingReport"
import StatementOfAccount from "./Pages/Reports/ReceivablesAgingReport/StatementOfAccount"

// WHOLESALE
import WholesaleInvoice from "./Pages/SalesModules/SalesInvoice/SalesInvoice"
import SalesInvoiceForm from "./Pages/SalesModules/SalesInvoice/SalesInvoiceForm"
import SalesInvoicePrint from "./Pages/SalesModules/SalesInvoice/SalesInvoicePrint"
import Terminals from "./Pages/Manage/terminals"
import InventoryLevel from "./Pages/Manage/InventoryLevel"
import FormInventoryLevel from "./Pages/Manage/InventoryLevel/FormInventoryLevel"
import NestedCategoryForm from "./Pages/Manage/Category/NestedCategoryForm"
import BranchAdjustmentDynamic from "./Pages/Inventory/ItemList/BranchAdjustmentDynamic"

// REPORTS
import AuditTrails from "./Pages/Reports/PosReports/AuditTrails"
import Ejournal from "./Pages/Reports/PosReports/Ejournal"
import XReading from "./Pages/Reports/PosReports/XReading"
import ZReading from "./Pages/Reports/PosReports/ZReading"
import AttendanceForm from "./Pages/Reports/DailyAttendanceList/AttendanceForm"
import ExpensesForm from "./Pages/Reports/DailyExpenses/ExpensesForm"
import ViewCashCountByShift from "./Pages/Reports/DailyCashCounts/ViewCashCountByShift"
import StoreDepositForm from "./Pages/Reports/StoreDeposit/StoreDepositForm"
import SupplierPriceTable from "./Components/Table/SupplierPriceTable"
import SupplierPriceReport from "./Pages/Reports/SupplierPrice/SupplierPriceReport"
import RetailTopSellingPrice from "./Pages/Reports/RetailTopSellingItem/RetailTopSellingItem"
import WholesaleTopSellingPrice from "./Pages/Reports/WholesaleTopSellingItem/WholesaleTopSellingItem"
import PrintPurchaseRequest from "./Pages/Purchases/PurchaseRequest/Components/PrintPurchaseRequest"
import ItemPricesV2 from "./Pages/Manage/ItemPrices/ItemPricesV2"
import NestedCategoryForm2 from "./Pages/Manage/Category/NestedCategoryForm2"
import FormCategory2 from "./Pages/Manage/Category/FormCategory2"

/**
 *  ---- App ----
 */
function App() {
  document.title = "ELHMHURST ERP"
  document.body.style = "background: #F8F7F7;"

  const [token, setAuthentication] = useState(getToken())
  const type = getType()

  React.useEffect(() => {
    setAuthentication(getToken())
  }, [])

  async function handleLogout() {
    toast.error("Expired Token. Logging out...", { style: toastStyle() })

    removeUserSession()

    // Adding delay before reloading
    setTimeout(() => {
      window.location.reload()
    }, 1000)
  }

  async function checkToken() {
    // let isNotExpired = await checkTokenStatus()
  }

  // Auto logout when the token expires
  React.useEffect(() => {
    let user = localStorage.getItem("user")
    if (!user) return

    let token = localStorage.getItem("token")
    if (!token) {
      //
      handleLogout()
    } else {
      //
      checkToken()
    }
  }, [])

  return (
    <div className="page">
      <Toaster
        position="top-right"
        reverseOrder={false}
        toastOptions={{ style: { toastStyle } }}
      />
      <Router>
        <Routes>
          {/* -------------------------------------------------- */}
          {/* DASHBOARD */}

          {/* ! hide dashboard for now except for admin people */}
          <Route path="/" element={token ? <Dashboard4 /> : <Login />} />
          <Route
            path="/dashboard"
            element={token ? <Dashboard4 /> : <Navigate to="/" />}
          />
          {/* <Route
                        path="/"
                        element={
                            token ? (
                                type === "admin" ? (
                                    <Dashboard3 />
                                ) : (
                                    <Franchise />
                                )
                            ) : (
                                <Login />
                            )
                        }
                    />
                    <Route
                        path="/dashboard"
                        element={
                            token ? (
                                type === "admin" ? (
                                    <Dashboard3 />
                                ) : (
                                    <Franchise />
                                )
                            ) : (
                                <Navigate to="/" />
                            )
                        }
                    /> */}

          {/* -------------------------------------------------- */}
          {/* FRANCHISE - Franchise Register */}
          <Route
            path="/franchise"
            element={
              token && (type === "admin" || type === "franchise_officer") ? (
                <Franchise />
              ) : (
                <Navigate to="/" />
              )
            }
          />
          <Route
            path="/franchise/add"
            element={
              token && (type === "admin" || type === "franchise_officer") ? (
                <FormFranchiseInvoice add />
              ) : (
                <Navigate to="/" />
              )
            }
          />
          <Route
            path="/franchise/edit/:pi_id"
            element={
              token && type === "admin" ? (
                // (type === "admin" ||
                //     type === "franchise_officer") ? (
                <FormFranchiseInvoice edit />
              ) : (
                <Navigate to="/" />
              )
            }
          />
          <Route
            path="/franchise/print/:franchisee_id"
            element={
              token && (type === "admin" || type === "franchise_officer") ? (
                <PrintFranchiseInvoice />
              ) : (
                <Navigate to="/" />
              )
            }
          />
          {/* SALES QUOTATION */}
          <Route
            path="/salesquotation"
            element={
              token &&
              (type === "admin" ||
                type === "bidding_officer" ||
                type === "wholesale_head" ||
                type === "wholesale_assistant") ? (
                <SalesQuotation />
              ) : (
                <Navigate to="/" />
              )
            }
          />
          <Route
            path="/salesquotation/add"
            element={
              token &&
              (type === "admin" ||
                type === "bidding_officer" ||
                type === "wholesale_head" ||
                type === "wholesale_assistant") ? (
                <SalesQuotationForm add />
              ) : (
                <Navigate to="/" />
              )
            }
          />
          <Route
            path="/salesquotation/edit/:id"
            element={
              token &&
              (type === "admin" ||
                type === "bidding_officer" ||
                type === "wholesale_head" ||
                type === "wholesale_assistant") ? (
                <SalesQuotationForm edit />
              ) : (
                <Navigate to="/" />
              )
            }
          />
          <Route
            path="/salesquotation/print/:id"
            element={
              token &&
              (type === "admin" ||
                type === "bidding_officer" ||
                type === "wholesale_head" ||
                type === "wholesale_assistant") ? (
                <SalesQuotationPrint />
              ) : (
                <Navigate to="/" />
              )
            }
          />
          {/* SALES ORDER */}
          <Route
            path="/salesorder"
            element={
              token &&
              (type === "admin" ||
                type === "bidding_officer" ||
                type === "wholesale_head" ||
                type === "wholesale_assistant") ? (
                <SalesOrder />
              ) : (
                <Navigate to="/" />
              )
            }
          />
          <Route
            path="/salesorder/add"
            element={
              token &&
              (type === "admin" ||
                type === "bidding_officer" ||
                type === "wholesale_head" ||
                type === "wholesale_assistant") ? (
                <SalesOrderForm add />
              ) : (
                <Navigate to="/" />
              )
            }
          />
          <Route
            path="/salesorder/add/:id"
            element={
              token &&
              (type === "admin" ||
                type === "bidding_officer" ||
                type === "wholesale_head" ||
                type === "wholesale_assistant") ? (
                <SalesOrderForm add />
              ) : (
                <Navigate to="/" />
              )
            }
          />
          <Route
            path="/salesorder/edit/:id"
            element={
              token &&
              (type === "admin" ||
                type === "bidding_officer" ||
                type === "wholesale_head" ||
                type === "wholesale_assistant") ? (
                <SalesOrderForm edit />
              ) : (
                <Navigate to="/" />
              )
            }
          />
          <Route
            path="/salesorder/print/:id"
            element={
              token &&
              (type === "admin" ||
                type === "bidding_officer" ||
                type === "wholesale_head" ||
                type === "wholesale_assistant") ? (
                <SalesOrderPrint />
              ) : (
                <Navigate to="/" />
              )
            }
          />

          {/* SALES INVOICE */}
          <Route
            path="/wholesaleinvoice"
            element={
              token &&
              (type === "admin" ||
                type === "account_officer" ||
                type === "wholesale_head" ||
                type === "wholesale_assistant") ? (
                <WholesaleInvoice />
              ) : (
                <Navigate to="/" />
              )
            }
          />
          <Route
            path="/wholesaleinvoice/add/:id"
            element={
              token &&
              (type === "admin" ||
                type === "account_officer" ||
                type === "wholesale_head" ||
                type === "wholesale_assistant") ? (
                <SalesInvoiceForm add />
              ) : (
                <Navigate to="/" />
              )
            }
          />
          <Route
            path="/wholesaleinvoice/edit/:id"
            element={
              token &&
              (type === "admin" ||
                type === "account_officer" ||
                type === "wholesale_head" ||
                type === "wholesale_assistant") ? (
                <SalesInvoiceForm edit />
              ) : (
                <Navigate to="/" />
              )
            }
          />
          <Route
            path="/wholesaleinvoice/print/:id"
            element={
              token &&
              (type === "admin" ||
                type === "account_officer" ||
                type === "wholesale_head" ||
                type === "wholesale_assistant") ? (
                <SalesInvoicePrint />
              ) : (
                <Navigate to="/" />
              )
            }
          />

          {/* SALES PAYMENT */}
          <Route
            path="/salespayment"
            element={
              token &&
              (type === "admin" ||
                type === "wholesale_head" ||
                type === "wholesale_assistant" ||
                type === "account_officer") ? (
                <SalesPayments />
              ) : (
                <Navigate to="/" />
              )
            }
          />
          <Route
            path="/salespayment/add/:type"
            element={
              token &&
              (type === "admin" ||
                type === "wholesale_head" ||
                type === "wholesale_assistant" ||
                type === "account_officer") ? (
                <SalesPaymentForm add />
              ) : (
                <Navigate to="/" />
              )
            }
          />
          <Route
            path="/salespayment/edit/:id/:type"
            element={
              token &&
              (type === "admin" ||
                type === "wholesale_head" ||
                type === "wholesale_assistant" ||
                type === "account_officer") ? (
                <SalesPaymentForm edit />
              ) : (
                <Navigate to="/" />
              )
            }
          />
          <Route
            path="/salespayment/view/:id/:type"
            element={
              token &&
              (type === "admin" ||
                type === "wholesale_head" ||
                type === "wholesale_assistant" ||
                type === "account_officer") ? (
                <SalesPaymentView />
              ) : (
                <Navigate to="/" />
              )
            }
          />
          {/* RECEIVABLES AGING REPORT */}
          <Route
            path="/receivablesagingreport"
            element={
              token && (type === "admin" || type === "account_officer") ? (
                <ReceivablesAgingReport />
              ) : (
                <Navigate to="/" />
              )
            }
          />
          <Route
            path="/statementofaccount/:id"
            element={
              token && (type === "admin" || type === "account_officer") ? (
                <StatementOfAccount />
              ) : (
                <Navigate to="/" />
              )
            }
          />

          {/* FRANCHISE - Franchise Sales Invoice */}
          <Route
            path="/salesinvoice"
            element={
              token && (type === "admin" || type === "franchise_officer") ? (
                <SalesInvoice />
              ) : (
                <Navigate to="/" />
              )
            }
          />
          <Route
            path="/salesinvoice/add"
            element={
              token && (type === "admin" || type === "franchise_officer") ? (
                <FormSalesInvoice add />
              ) : (
                <Navigate to="/" />
              )
            }
          />
          <Route
            path="/salesinvoice/edit/:franchisee_sale_id"
            element={
              token && (type === "admin" || type === "franchise_officer") ? (
                <FormSalesInvoice edit />
              ) : (
                <Navigate to="/" />
              )
            }
          />
          <Route
            path="/salesinvoice/process/:franchisee_sale_id"
            element={
              token && (type === "admin" || type === "franchise_officer") ? (
                <FormSalesInvoice process />
              ) : (
                <Navigate to="/" />
              )
            }
          />
          <Route
            path="/salesinvoice/createinvoice/:franchisee_sale_id"
            element={
              token && (type === "admin" || type === "franchise_officer") ? (
                <FormSalesInvoice createinvoice />
              ) : (
                // <FormCreateSalesInvoice edit />
                <Navigate to="/" />
              )
            }
          />
          <Route
            path="/salesinvoice/print/:franchisee_sale_id"
            element={
              token &&
              (type === "admin" ||
                type === "purchasing_officer" ||
                type === "inventory_officer" ||
                type === "franchise_officer") ? (
                <PrintSalesInvoice />
              ) : (
                <Navigate to="/salesinvoice" />
              )
            }
          />

          {/* FRANCHISE - Franchise Sales Report */}
          <Route
            path="/franchise_sales_report"
            element={
              token && (type === "admin" || type === "franchise_officer") ? (
                <FranchiseSalesReport />
              ) : (
                <Navigate to="/" />
              )
            }
          />

          {/* FRANCHISE - Monthly Sales Billing */}
          <Route
            path="/franchisebilling"
            element={
              token && (type === "admin" || type === "franchise_officer") ? (
                <FranchiseBilling />
              ) : (
                <Navigate to="/" />
              )
            }
          />
          <Route
            path="/franchisebilling/reports"
            element={
              token && (type === "admin" || type === "franchise_officer") ? (
                <FranchiseBilling reports />
              ) : (
                <Navigate to="/" />
              )
            }
          />
          <Route
            path="/franchisebilling/add/"
            element={
              token && (type === "admin" || type === "franchise_officer") ? (
                <FranchiseBillingForm add />
              ) : (
                <Navigate to="/" />
              )
            }
          />
          {/* <Route
                        path="/franchisebilling/add/:id"
                        element={
                            token &&
                            (type === "admin" ||
                                type === "franchise_officer") ? (
                                <FranchiseBillingForm add />
                            ) : (
                                <Navigate to="/" />
                            )
                        }
                    /> */}
          <Route
            path="/franchisebilling/edit/:id"
            element={
              token && (type === "admin" || type === "franchise_officer") ? (
                <FranchiseBillingForm edit />
              ) : (
                <Navigate to="/" />
              )
            }
          />

          <Route
            path="/franchisebilling/view/:id"
            element={
              token && (type === "admin" || type === "franchise_officer") ? (
                <FranchiseBillingView add />
              ) : (
                <Navigate to="/" />
              )
            }
          />
          {/* FRANCHISE - Receivables */}
          <Route
            path="/receivables"
            element={
              token && (type === "admin" || type === "franchise_officer") ? (
                <Receivables />
              ) : (
                <Navigate to="/" />
              )
            }
          />
          <Route
            path="/receivables/print/:id"
            element={
              token && (type === "admin" || type === "franchise_officer") ? (
                <PrintReceivable />
              ) : (
                <Navigate to="/" />
              )
            }
          />
          {/* FRANCHISE - Payments */}
          <Route
            path="/payments"
            element={
              token && (type === "admin" || type === "franchise_officer") ? (
                <Payments />
              ) : (
                <Navigate to="/" />
              )
            }
          />
          <Route
            path="/payments/viewmultiple/:id/:type"
            element={
              token && (type === "admin" || type === "franchise_officer") ? (
                <MultiplePaymentsView />
              ) : (
                <Navigate to="/" />
              )
            }
          />
          <Route
            path="/payments/print/:id"
            element={
              token && (type === "admin" || type === "franchise_officer") ? (
                <PaymentsPrint />
              ) : (
                <Navigate to="/" />
              )
            }
          />

          {/* -------------------------------------------------- */}
          {/* PURCHASES */}
          {/* PURCHASES - Purchase Request */}

          {/* PURCHASES - Purchase Order Register */}
          <Route
            path="/purchaserequest"
            element={
              token &&
              (type === "admin" ||
                type === "bidding_officer" ||
                type === "purchasing_officer" ||
                type === "warehouse_manager" ||
                type === "warehouse_assistant" ||
                type === "wholesale_head" ||
                type === "wholesale_assistant" ||
                type === "branch_oic" ||
                type === "branch_inventory_officer") ? (
                <PurchaseRequest />
              ) : (
                <Navigate to="/" />
              )
            }
          />
          <Route
            path="/purchaserequest/add"
            element={
              token &&
              (type === "admin" ||
                type === "bidding_officer" ||
                type === "purchasing_officer" ||
                type === "warehouse_manager" ||
                type === "warehouse_assistant" ||
                type === "wholesale_head" ||
                type === "wholesale_assistant" ||
                type === "branch_oic" ||
                type === "branch_inventory_officer") ? (
                <AddPurchaseRequest />
              ) : (
                <Navigate to="/" />
              )
            }
          />
          <Route
            path="/purchaserequest/edit/:id"
            element={
              token &&
              (type === "admin" ||
                type === "bidding_officer" ||
                type === "purchasing_officer" ||
                type === "warehouse_manager" ||
                type === "warehouse_assistant" ||
                type === "wholesale_head" ||
                type === "wholesale_assistant" ||
                type === "branch_oic" ||
                type === "branch_inventory_officer") ? (
                <EditPurchaseRequest edit />
              ) : (
                <Navigate to="/" />
              )
            }
          />
          {/* TO CREATE PO FROM PR */}
          <Route
            path="/purchaserequest/generate/:id"
            element={
              token &&
              (type === "admin" ||
                type === "bidding_officer" ||
                type === "purchasing_officer" ||
                type === "warehouse_manager" ||
                type === "warehouse_assistant" ||
                type === "wholesale_head" ||
                type === "wholesale_assistant" ||
                type === "branch_oic" ||
                type === "branch_inventory_officer") ? (
                <AddPurchaseOrder generate />
              ) : (
                <Navigate to="/" />
              )
            }
          />
          <Route
            path="/purchaserequest/view/:id"
            element={
              token &&
              (type === "admin" ||
                type === "bidding_officer" ||
                type === "purchasing_officer" ||
                type === "warehouse_manager" ||
                type === "warehouse_assistant" ||
                type === "wholesale_head" ||
                type === "wholesale_assistant" ||
                type === "branch_oic" ||
                type === "branch_inventory_officer") ? (
                <ViewPurchaseRequest />
              ) : (
                <Navigate to="/" />
              )
            }
          />
          <Route
            path="/purchaserequest/review/:id"
            element={
              token &&
              (type === "admin" ||
                type === "bidding_officer" ||
                type === "purchasing_officer" ||
                type === "warehouse_manager" ||
                type === "warehouse_assistant" ||
                type === "wholesale_head" ||
                type === "wholesale_assistant" ||
                type === "branch_oic" ||
                type === "branch_inventory_officer") ? (
                <ReviewPurchaseRequest />
              ) : (
                <Navigate to="/" />
              )
            }
          />
          <Route
            path="/purchaserequest/print/:id"
            element={
              token &&
              (type === "admin" ||
                type === "bidding_officer" ||
                type === "purchasing_officer" ||
                type === "warehouse_manager" ||
                type === "warehouse_assistant" ||
                type === "wholesale_head" ||
                type === "wholesale_assistant" ||
                type === "branch_oic" ||
                type === "branch_inventory_officer") ? (
                <PrintPurchaseRequest />
              ) : (
                <Navigate to="/" />
              )
            }
          />

          {/* PURCHASES - Purchase Order Register */}
          <Route
            path="/purchaseorders"
            element={
              token &&
              (type === "admin" ||
                type === "bidding_officer" ||
                type === "purchasing_officer" ||
                type === "warehouse_manager" ||
                type === "warehouse_assistant") ? (
                <PurchaseOrders />
              ) : (
                <Navigate to="/" />
              )
            }
          />
          <Route
            path="/purchaseorders/add"
            // element={<AddPurchaseOrder add/>}
            element={
              token &&
              (type === "admin" ||
                type === "bidding_officer" ||
                type === "purchasing_officer" ||
                type === "warehouse_manager" ||
                type === "warehouse_assistant") ? (
                <AddPurchaseOrder add />
              ) : (
                <Navigate to="/" />
              )
            }
          />
          <Route
            path="/purchaseorders/edit/:id/:type"
            element={
              token &&
              (type === "admin" ||
                type === "bidding_officer" ||
                type === "purchasing_officer" ||
                type === "warehouse_manager" ||
                type === "warehouse_assistant") ? (
                <EditPurchaseOrder />
              ) : (
                <Navigate to="/" />
              )
            }
          />
          <Route
            path="/purchaseorders/review/:state/:id"
            element={
              token &&
              (type === "admin" ||
                type === "bidding_officer" ||
                type === "purchasing_officer" ||
                type === "warehouse_manager" ||
                type === "warehouse_assistant") ? (
                <ReviewPurchaseOrder />
              ) : (
                <Navigate to="/" />
              )
            }
          />
          <Route
            path="/purchaseorders/print/:id"
            element={
              token &&
              (type === "admin" ||
                type === "bidding_officer" ||
                type === "purchasing_officer" ||
                type === "warehouse_manager" ||
                type === "warehouse_assistant") ? (
                <PrintPurchaseOrder />
              ) : (
                <Navigate to="/" />
              )
            }
          />
          {/* PURCHASES - Purchase Invoice Register */}
          <Route
            path="/purchaseinvoices"
            element={
              token &&
              (type === "admin" ||
                type === "account_officer" ||
                type === "purchasing_officer" ||
                type === "warehouse_manager" ||
                type === "warehouse_assistant") ? (
                <PurchaseInvoices />
              ) : (
                <Navigate to="/" />
              )
            }
          />
          <Route
            path="/purchaseinvoices/add/:po_id"
            element={
              token &&
              (type === "admin" ||
                type === "account_officer" ||
                type === "purchasing_officer" ||
                type === "warehouse_manager" ||
                type === "warehouse_assistant") ? (
                <FormPurchaseInvoice add />
              ) : (
                <Navigate to="/" />
              )
            }
          />
          <Route
            path="/purchaseinvoices/edit/:pi_id"
            element={
              token &&
              (type === "admin" ||
                type === "account_officer" ||
                type === "purchasing_officer" ||
                type === "warehouse_manager" ||
                type === "warehouse_assistant") ? (
                <FormPurchaseInvoice edit />
              ) : (
                <Navigate to="/" />
              )
            }
          />
          <Route
            path="/purchaseinvoices/print/:id"
            element={
              token &&
              (type === "admin" ||
                type === "account_officer" ||
                type === "purchasing_officer" ||
                type === "warehouse_manager" ||
                type === "warehouse_assistant") ? (
                <PrintPurchaseInvoice />
              ) : (
                <Navigate to="/" />
              )
            }
          />
          <Route
            path="/purchaseinvoices/pay-check"
            element={
              token &&
              (type === "admin" ||
                type === "account_officer" ||
                type === "purchasing_officer" ||
                type === "warehouse_manager" ||
                type === "warehouse_assistant") ? (
                <PayPurchaseInvoice />
              ) : (
                <Navigate to="/" />
              )
            }
          />

          {/* Purchase Return */}
          <Route
            path="/purchasereturn"
            // element={<PurchaseReturn />}
            element={
              token && (type === "admin" || type === "purchasing_officer") ? (
                <PurchaseReturn />
              ) : (
                <Navigate to="/" />
              )
            }
          />
          <Route
            path="/purchasereturn/add/:id"
            // element={<PurchaseReturnForm add />}
            element={
              token && (type === "admin" || type === "purchasing_officer") ? (
                <PurchaseReturnForm add />
              ) : (
                <Navigate to="/" />
              )
            }
          />
          <Route
            path="/purchasereturn/edit/:id"
            // element={<PurchaseReturnForm edit />}
            element={
              token && (type === "admin" || type === "purchasing_officer") ? (
                <PurchaseReturnForm edit />
              ) : (
                <Navigate to="/" />
              )
            }
          />
          <Route
            path="/purchasereturn/view/:po_id"
            // element={<PrintPurchaseReturn />}
            element={
              token && (type === "admin" || type === "purchasing_officer") ? (
                <PrintPurchaseReturn />
              ) : (
                <Navigate to="/" />
              )
            }
          />

          {/* Purchase Replacement */}
          <Route
            path="/purchasereplacement"
            // element={<PurchaseReplacement />}
            element={
              token && (type === "admin" || type === "purchasing_officer") ? (
                <PurchaseReplacement />
              ) : (
                <Navigate to="/" />
              )
            }
          />
          <Route
            path="/purchasereplacement/add/:id"
            // element={<PurchaseReplacementForm add />}
            element={
              token && (type === "admin" || type === "purchasing_officer") ? (
                <PurchaseReplacementForm add />
              ) : (
                <Navigate to="/" />
              )
            }
          />
          <Route
            path="/purchasereplacement/edit/:id"
            // element={<PurchaseReplacementForm edit />}
            element={
              token && (type === "admin" || type === "purchasing_officer") ? (
                <PurchaseReplacementForm edit />
              ) : (
                <Navigate to="/" />
              )
            }
          />
          <Route
            path="/purchasereplacement/view/:id"
            // element={<PrintPurchaseReplacement />}
            element={
              token && (type === "admin" || type === "purchasing_officer") ? (
                <ViewPurchaseReplacement />
              ) : (
                <Navigate to="/" />
              )
            }
          />

          {/* PURCHASES - Pay Supplier */}
          <Route
            path="/paysuppliers"
            // element={<PaySuppliers />}
            element={token ? <PaySuppliers /> : <Navigate to="/" />}
          />
          <Route
            path="/paysuppliers/add/:type"
            // element={<FormPaySupplier add />}
            element={
              token &&
              (type === "admin" ||
                type === "purchasing_officer" ||
                type === "account_officer") ? (
                <FormPaySupplier add />
              ) : (
                <Navigate to="/" />
              )
            }
          />
          <Route
            path="/paysuppliers/edit/:id/:type"
            // element={<FormPaySupplier edit />}
            element={
              token &&
              (type === "admin" ||
                type === "account_officer" ||
                type === "purchasing_officer") ? (
                <FormPaySupplier edit />
              ) : (
                <Navigate to="/" />
              )
            }
          />
          <Route
            path="/paysuppliers/view/:id/:type"
            // element={<ViewPaySupplier />}
            element={
              token &&
              (type === "admin" ||
                type === "purchasing_officer" ||
                type === "account_officer") ? (
                <ViewPaySupplier />
              ) : (
                <Navigate to="/" />
              )
            }
          />
          <Route
            path="/paysuppliers/view-invoice/:id/:type"
            // element={<ViewInvoice />}
            element={
              token &&
              (type === "admin" ||
                type === "purchasing_officer" ||
                type === "account_officer") ? (
                <ViewInvoice />
              ) : (
                <Navigate to="/" />
              )
            }
          />

          {/* -------------------------------------------------- */}
          {/* SUPPLIES */}
          <Route
            path="/suppliesexpenses"
            element={
              token &&
              (type === "admin" ||
                type === "bidding_officer" ||
                type === "purchasing_officer") ? (
                <SuppliesExpenses />
              ) : (
                <Navigate to="/" />
              )
            }
          />

          <Route
            path="/payablesagingreport"
            element={
              token &&
              (type === "admin" ||
                type === "inventory_officer" ||
                type === "purchasing_officer" ||
                type === "account_officer" ||
                type === "hr_officer" ||
                type === "purchasing_staff") ? (
                <PayablesAgingReport />
              ) : (
                <Navigate to="/" />
              )
            }
          />
          <Route
            path="/expensebytype"
            element={
              token &&
              (type === "admin" ||
                type === "inventory_officer" ||
                type === "purchasing_officer" ||
                type === "hr_officer" ||
                type === "purchasing_staff") ? (
                <ExpenseByType />
              ) : (
                <Navigate to="/" />
              )
            }
          />
          <Route
            path="/expensebydate"
            element={
              token &&
              (type === "admin" ||
                type === "inventory_officer" ||
                type === "purchasing_officer" ||
                type === "hr_officer" ||
                type === "purchasing_staff") ? (
                <ExpenseByDate />
              ) : (
                <Navigate to="/" />
              )
            }
          />
          <Route
            path="/expenses"
            element={
              token &&
              (type === "admin" ||
                type === "inventory_officer" ||
                type === "purchasing_officer" ||
                type === "hr_officer" ||
                type === "purchasing_staff") ? (
                <ExpenseRegister />
              ) : (
                <Navigate to="/" />
              )
            }
          />

          <Route
            path="/suppliesexpenses/add"
            element={
              token &&
              (type === "admin" ||
                type === "bidding_officer" ||
                type === "purchasing_officer") ? (
                <FormSuppliesExpenses add />
              ) : (
                <Navigate to="/" />
              )
            }
          />
          <Route
            path="/suppliesexpenses/review/:id"
            element={
              token &&
              (type === "admin" ||
                type === "bidding_officer" ||
                type === "purchasing_officer") ? (
                <ReviewSuppliesExpense />
              ) : (
                <Navigate to="/" />
              )
            }
          />

          <Route
            path="/suppliesexpenses/edit/:type/:id"
            element={
              token &&
              (type === "admin" ||
                type === "bidding_officer" ||
                type === "purchasing_officer") ? (
                <FormSuppliesExpenses edit />
              ) : (
                <Navigate to="/" />
              )
            }
          />

          <Route
            path="/suppliesexpenses/print/:id"
            element={
              token &&
              (type === "admin" ||
                type === "bidding_officer" ||
                type === "purchasing_officer") ? (
                <PrintSuppliesExpense />
              ) : (
                <Navigate to="/" />
              )
            }
          />

          {/* SUPPLIES -- Purchase Order Register */}
          <Route
            path="/se/purchaseorders"
            element={
              token && (type === "admin" || type === "purchasing_officer") ? (
                <PO />
              ) : (
                <Navigate to="/" />
              )
            }
          />
          <Route
            path="/se/purchaseorders/add"
            element={
              token && (type === "admin" || type === "purchasing_officer") ? (
                <AddPO />
              ) : (
                <Navigate to="/" />
              )
            }
          />
          <Route
            path="/se/purchaseorders/edit/:id/:type"
            element={
              token && (type === "admin" || type === "purchasing_officer") ? (
                <EditPO />
              ) : (
                <Navigate to="/" />
              )
            }
          />
          <Route
            path="/se/purchaseorders/review/:state/:id"
            element={
              token && (type === "admin" || type === "purchasing_officer") ? (
                <ReviewPO />
              ) : (
                <Navigate to="/" />
              )
            }
          />
          <Route
            path="/se/purchaseorders/print/:id"
            element={
              token && (type === "admin" || type === "purchasing_officer") ? (
                <PrintPO />
              ) : (
                <Navigate to="/" />
              )
            }
          />

          {/* SUPPLIES -- Purchase Invoice Register */}
          <Route
            path="/se/purchaseinvoices"
            element={
              token &&
              (type === "admin" ||
                type === "account_officer" ||
                type === "purchasing_officer") ? (
                <PI />
              ) : (
                <Navigate to="/" />
              )
            }
          />
          <Route
            path="/se/purchaseinvoices/add/:po_id"
            element={
              token &&
              (type === "admin" ||
                type === "account_officer" ||
                type === "purchasing_officer") ? (
                <SEFormPurchaseInvoice add />
              ) : (
                <Navigate to="/" />
              )
            }
          />
          <Route
            path="/se/purchaseinvoices/edit/:pi_id"
            element={
              token &&
              (type === "admin" ||
                type === "account_officer" ||
                type === "purchasing_officer") ? (
                <SEFormPurchaseInvoice edit />
              ) : (
                <Navigate to="/" />
              )
            }
          />
          <Route
            path="/se/purchaseinvoices/print/:id"
            element={
              token &&
              (type === "admin" ||
                type === "account_officer" ||
                type === "purchasing_officer") ? (
                <PrintPI />
              ) : (
                <Navigate to="/" />
              )
            }
          />
          <Route
            path="/se/purchaseinvoices/pay-check"
            element={
              token &&
              (type === "admin" ||
                type === "account_officer" ||
                type === "purchasing_officer") ? (
                <PayPI />
              ) : (
                <Navigate to="/" />
              )
            }
          />

          <Route
            path="/se/purchaseinvoices/pay-check"
            element={
              token &&
              (type === "admin" ||
                type === "account_officer" ||
                type === "purchasing_officer") ? (
                <PayPI />
              ) : (
                <Navigate to="/" />
              )
            }
          />

          <Route
            path="/se/purchaseinvoices/pay-check"
            element={
              token &&
              (type === "admin" ||
                type === "account_officer" ||
                type === "purchasing_officer") ? (
                <PayPI />
              ) : (
                <Navigate to="/" />
              )
            }
          />

          <Route
            path="/se/purchaseinvoices/pay-check"
            element={
              token &&
              (type === "admin" ||
                type === "account_officer" ||
                type === "purchasing_officer") ? (
                <PayPI />
              ) : (
                <Navigate to="/" />
              )
            }
          />

          <Route
            path="/se/purchaseinvoices/pay-check"
            element={
              token &&
              (type === "admin" ||
                type === "account_officer" ||
                type === "purchasing_officer") ? (
                <PayPI />
              ) : (
                <Navigate to="/" />
              )
            }
          />

          <Route
            path="/se/purchaseinvoices/pay-check"
            element={
              token &&
              (type === "admin" ||
                type === "account_officer" ||
                type === "purchasing_officer") ? (
                <PayPI />
              ) : (
                <Navigate to="/" />
              )
            }
          />

          <Route
            path="/purchaseissuedpayment"
            element={
              token &&
              (type === "admin" ||
                type === "account_officer" ||
                type === "purchasing_officer") ? (
                <PurchaseIssuedPayment />
              ) : (
                <Navigate to="/" />
              )
            }
          />

          {/* SUPPLIES - Pay Suppliers */}
          <Route
            path="/se/paysuppliers"
            // element={<PaySuppliersE />}
            element={
              token &&
              (type === "admin" ||
                type === "purchasing_officer" ||
                type === "account_officer") ? (
                <PaySuppliersE />
              ) : (
                <Navigate to="/" />
              )
            }
          />
          <Route
            path="/se/paysuppliers/add/:type"
            // element={<FormPaySupplierE add />}
            element={
              token &&
              (type === "admin" ||
                type === "purchasing_officer" ||
                type === "account_officer") ? (
                <FormPaySupplierE add />
              ) : (
                <Navigate to="/" />
              )
            }
          />
          <Route
            path="/se/paysuppliers/edit/:id/:type"
            // element={<FormPaySupplierE edit />}
            element={
              token &&
              (type === "admin" ||
                type === "account_officer" ||
                type === "hr_officer") ? (
                <FormPaySupplierE edit />
              ) : (
                <Navigate to="/" />
              )
            }
          />
          <Route
            path="/se/paysuppliers/view/:id/:type"
            // element={<ViewPaySupplierE />}
            element={
              token &&
              (type === "admin" ||
                type === "purchasing_officer" ||
                type === "account_officer") ? (
                <ViewPaySupplierE />
              ) : (
                <Navigate to="/" />
              )
            }
          />
          <Route
            path="/se/paysuppliers/view-invoice/:id/:type"
            // element={<ViewInvoiceSe />}
            element={
              token &&
              (type === "admin" ||
                type === "purchasing_officer" ||
                type === "account_officer") ? (
                <ViewInvoiceSe />
              ) : (
                <Navigate to="/" />
              )
            }
          />

          {/* -------------------------------------------------- */}
          {/* INVENTORY  */}
          <Route
            path="/itemlists"
            element={
              token &&
              (type === "admin" ||
                type === "purchasing_officer" ||
                type === "warehouse_manager" ||
                type === "warehouse_assistant" ||
                type === "wholesale_head" ||
                type === "wholesale_assistant") ? (
                <ItemLists />
              ) : (
                <Navigate to="/" />
              )
            }
          />
          <Route
            path="/itemlists/branch-adjustment/:id"
            element={
              token &&
              (type === "admin" ||
                type === "purchasing_officer" ||
                type === "warehouse_manager" ||
                type === "warehouse_assistant" ||
                type === "wholesale_head" ||
                type === "wholesale_assistant") ? (
                <BranchAdjustment />
              ) : (
                <Navigate to="/" />
              )
            }
          />
          <Route
            path="/branch-adjustments/add/:type"
            element={
              token &&
              (type === "admin" ||
                type === "purchasing_officer" ||
                type === "warehouse_manager" ||
                type === "warehouse_assistant" ||
                type === "wholesale_head" ||
                type === "wholesale_assistant" ||
                type === "branch_oic") ? (
                <BranchAdjustmentDynamic />
              ) : (
                <Navigate to="/" />
              )
            }
          />
          <Route
            path="/itemlists/itemdetails/:id"
            element={
              token &&
              (type === "admin" ||
                type === "purchasing_officer" ||
                type === "warehouse_manager" ||
                type === "warehouse_assistant" ||
                type === "wholesale_head" ||
                type === "wholesale_assistant") ? (
                <ItemDetails2 />
              ) : (
                <Navigate to="/" />
              )
            }
          />
          <Route
            path="/itemlists/history/:branch_id/:item_id/:item_unit_id/:unit"
            element={
              token &&
              (type === "admin" ||
                type === "purchasing_officer" ||
                type === "warehouse_manager" ||
                type === "warehouse_assistant" ||
                type === "wholesale_head" ||
                type === "wholesale_assistant") ? (
                <ItemHistory />
              ) : (
                <Navigate to="/" />
              )
            }
          />
          <Route
            path="/itemhistorysearch"
            element={
              token &&
              (type === "admin" ||
                type === "purchasing_officer" ||
                type === "warehouse_manager" ||
                type === "warehouse_assistant" ||
                type === "wholesale_head" ||
                type === "wholesale_assistant" ||
                type === "branch_oic" ||
                type === "branch_inventory_officer") ? (
                <ItemHistorySearch />
              ) : (
                <Navigate to="/" />
              )
            }
          />
          <Route
            path="/lowonstock"
            element={
              token &&
              (type === "admin" ||
                type === "purchasing_officer" ||
                type === "warehouse_manager" ||
                type === "warehouse_assistant" ||
                type === "wholesale_head" ||
                type === "wholesale_assistant" ||
                type === "branch_oic" ||
                type === "branch_inventory_officer") ? (
                <LowOnStock />
              ) : (
                <Navigate to="/" />
              )
            }
          />
          <Route
            path="/transfers"
            element={
              token &&
              (type === "admin" ||
                type === "warehouse_manager" ||
                type === "warehouse_assistant" ||
                type === "branch_oic" ||
                type === "branch_inventory_officer") ? (
                <Transfers />
              ) : (
                <Navigate to="/" />
              )
            }
          />
          <Route
            path="/incomingtransfers"
            element={
              token &&
              (type === "admin" ||
                type === "warehouse_manager" ||
                type === "warehouse_assistant" ||
                type === "branch_oic" ||
                type === "branch_inventory_officer") ? (
                <IncomingTransfers />
              ) : (
                <Navigate to="/" />
              )
            }
          />
          <Route
            path="/transfers/view/:id/:type"
            element={
              token &&
              (type === "admin" ||
                type === "warehouse_manager" ||
                type === "warehouse_assistant" ||
                type === "branch_oic" ||
                type === "branch_inventory_officer") ? (
                <ViewTransfer />
              ) : (
                <Navigate to="/" />
              )
            }
          />
          <Route
            path="/transfers/review/:id/:type"
            element={
              token &&
              (type === "admin" ||
                type === "warehouse_manager" ||
                type === "warehouse_assistant" ||
                type === "branch_oic" ||
                type === "branch_inventory_officer") ? (
                <ReviewTransfer />
              ) : (
                <Navigate to="/" />
              )
            }
          />
          <Route
            path="/transfers/add"
            element={
              token &&
              (type === "admin" ||
                type === "warehouse_manager" ||
                type === "branch_oic" ||
                type === "branch_inventory_officer") ? (
                <FormTransfer add />
              ) : (
                <Navigate to="/" />
              )
            }
          />
          <Route
            path="/transfers/edit/:id/:type"
            element={
              token &&
              (type === "admin" ||
                type === "warehouse_manager" ||
                type === "warehouse_assistant" ||
                type === "branch_oic" ||
                type === "branch_inventory_officer") ? (
                <FormTransfer edit />
              ) : (
                <Navigate to="/" />
              )
            }
          />
          <Route
            path="/transfers/add/:id"
            element={
              token &&
              (type === "admin" ||
                type === "warehouse_manager" ||
                type === "warehouse_assistant" ||
                type === "branch_oic" ||
                type === "branch_inventory_officer") ? (
                <FormTransfer request />
              ) : (
                <Navigate to="/" />
              )
            }
          />
          {/* TRANSFER RECEIVE */}

          <Route
            path="/transfer-receive"
            element={
              token &&
              (type === "admin" ||
                type === "warehouse_manager" ||
                type === "warehouse_assistant" ||
                type === "branch_oic" ||
                type === "branch_inventory_officer") ? (
                <TransferReceive />
              ) : (
                <Navigate to="/" />
              )
            }
          />
          <Route
            path="/transfer-receive/:type/:id"
            element={
              token &&
              (type === "admin" ||
                type === "warehouse_manager" ||
                type === "warehouse_assistant" ||
                type === "branch_oic" ||
                type === "branch_inventory_officer") ? (
                <FormReceiveTransfer edit />
              ) : (
                <Navigate to="/" />
              )
            }
          />
          <Route
            path="/transfer-receive/view/:id"
            element={
              token &&
              (type === "admin" ||
                type === "warehouse_manager" ||
                type === "warehouse_assistant" ||
                type === "branch_oic" ||
                type === "branch_inventory_officer") ? (
                <ViewTransferReceive edit />
              ) : (
                <Navigate to="/" />
              )
            }
          />
          {/* GATE PASS */}
          <Route
            path="/gatepass"
            element={
              token &&
              (type === "admin" ||
                type === "warehouse_manager" ||
                type === "warehouse_assistant" ||
                type === "branch_oic" ||
                type === "branch_inventory_officer") ? (
                <GatePass />
              ) : (
                <Navigate to="/" />
              )
            }
          />
          <Route
            path="/gatepass/add/:id"
            element={
              token &&
              (type === "admin" ||
                type === "warehouse_manager" ||
                type === "warehouse_assistant" ||
                type === "branch_oic" ||
                type === "branch_inventory_officer") ? (
                <GatePassForm add />
              ) : (
                <Navigate to="/" />
              )
            }
          />
          <Route
            path="/gatepass/edit/:id"
            element={
              token &&
              (type === "admin" ||
                type === "warehouse_manager" ||
                type === "warehouse_assistant" ||
                type === "branch_oic" ||
                type === "branch_inventory_officer") ? (
                <GatePassForm edit />
              ) : (
                <Navigate to="/" />
              )
            }
          />
          <Route
            path="/gatepass/view/:id"
            element={
              token &&
              (type === "admin" ||
                type === "warehouse_manager" ||
                type === "warehouse_assistant" ||
                type === "branch_oic" ||
                type === "branch_inventory_officer") ? (
                <GatePassView />
              ) : (
                <Navigate to="/" />
              )
            }
          />

          {/* REQUESTS */}
          <Route
            path="/requests"
            element={
              token &&
              (type === "admin" ||
                type === "purchasing_officer" ||
                type === "warehouse_manager" ||
                type === "warehouse_assistant" ||
                type === "branch_oic" ||
                type === "branch_inventory_officer") ? (
                <Requests />
              ) : (
                <Navigate to="/" />
              )
            }
          />
          <Route
            path="/requests/add"
            element={
              token &&
              (type === "admin" ||
                type === "purchasing_officer" ||
                type === "warehouse_manager" ||
                type === "warehouse_assistant" ||
                type === "branch_oic" ||
                type === "branch_inventory_officer") ? (
                <RequestForm add />
              ) : (
                <Navigate to="/" />
              )
            }
          />
          <Route
            path="/requests/edit/:id"
            element={
              token &&
              (type === "admin" ||
                type === "purchasing_officer" ||
                type === "warehouse_manager" ||
                type === "warehouse_assistant" ||
                type === "branch_oic" ||
                type === "branch_inventory_officer") ? (
                <RequestForm edit />
              ) : (
                <Navigate to="/" />
              )
            }
          />
          <Route
            path="/requests/view/:id/:type"
            element={
              token &&
              (type === "admin" ||
                type === "purchasing_officer" ||
                type === "warehouse_manager" ||
                type === "warehouse_assistant" ||
                type === "branch_oic" ||
                type === "branch_inventory_officer") ? (
                <ViewRequests />
              ) : (
                <Navigate to="/" />
              )
            }
          />
          <Route
            path="/branchinventory"
            element={
              token &&
              (type === "admin" ||
                type === "purchasing_officer" ||
                type === "warehouse_manager" ||
                type === "warehouse_assistant" ||
                type === "wholesale_head" ||
                type === "wholesale_assistant" ||
                type === "branch_oic" ||
                type === "branch_inventory_officer") ? (
                <BranchInventory />
              ) : (
                <Navigate to="/" />
              )
            }
          />
          {/* <Route
                        path="/itemhistory"
                        element={
                            token &&
                            (type === "admin" ||
                                type === "inventory_officer" ||
                                type === "purchasing_officer" ||
                                type === "operations_manager" ||
                                type === "fielder_officer_1" ||
                                type === "fielder_officer_2") ? (
                                <ItemHistoryFilter />
                            ) : (
                                <Navigate to="/" />
                            )
                        }
                    /> */}
          {
            <Route
              path="/adjustments"
              element={
                token &&
                (type === "admin" ||
                  type === "purchasing_officer" ||
                  type === "warehouse_manager" ||
                  type === "warehouse_assistant" ||
                  type === "wholesale_head" ||
                  type === "wholesale_assistant") ? (
                  <Adjustments />
                ) : (
                  <Navigate to="/" />
                )
              }
            />
          }

          {
            <Route
              path="/storeadjustments"
              element={
                token &&
                (type === "admin" ||
                  type === "purchasing_officer" ||
                  type === "warehouse_manager" ||
                  type === "warehouse_assistant" ||
                  type === "wholesale_head" ||
                  type === "wholesale_assistant" ||
                  type === "branch_oic" ||
                  type === "branch_inventory_officer") ? (
                  <StoreAdjustments />
                ) : (
                  <Navigate to="/" />
                )
              }
            />
          }

          <Route
            path="/adjustments/view/:id"
            element={
              token &&
              (type === "admin" ||
                type === "purchasing_officer" ||
                type === "warehouse_manager" ||
                type === "warehouse_assistant" ||
                type === "wholesale_head" ||
                type === "wholesale_assistant" ||
                type === "branch_oic" ||
                type === "branch_inventory_officer") ? (
                <ViewAdjustment />
              ) : (
                <Navigate to="/" />
              )
            }
          />

          <Route
            path="/builditem"
            element={
              token &&
              (type === "admin" ||
                type === "inventory_officer" ||
                type === "commissary_officer" ||
                // type === "hr_officer" ||
                type === "purchasing_officer") ? (
                <BuildItem />
              ) : (
                <Navigate to="/" />
              )
            }
          />
          <Route
            path="/builditem/view/:id"
            element={
              token &&
              (type === "admin" ||
                type === "inventory_officer" ||
                type === "commissary_officer" ||
                type === "purchasing_officer") ? (
                <BuildItemView />
              ) : (
                <Navigate to="/" />
              )
            }
          />
          <Route
            path="/builditem/add"
            element={
              token &&
              (type === "admin" ||
                type === "inventory_officer" ||
                type === "commissary_officer" ||
                type === "purchasing_officer") ? (
                <BuildItemForm add />
              ) : (
                <Navigate to="/" />
              )
            }
          />
          <Route
            path="/builditem/edit/:id"
            element={
              token &&
              (type === "admin" ||
                type === "inventory_officer" ||
                type === "commissary_officer" ||
                type === "purchasing_officer") ? (
                <BuildItemForm edit />
              ) : (
                <Navigate to="/" />
              )
            }
          />

          {/* -------------------------------------------------- */}
          {/* STORE REPORTS */}
          <Route
            path="/dailyattendancelist"
            element={
              token && (type === "admin" || type === "branch_oic") ? (
                <DailyAttendanceList />
              ) : (
                <Navigate to="/" />
              )
            }
          />
          <Route
            path="/dailyattendancelist/view/:type/:id/:date/:date_to/:shop"
            element={
              token && (type === "admin" || type === "branch_oic") ? (
                <ViewDailyAttendanceList />
              ) : (
                <Navigate to="/" />
              )
            }
          />
          <Route
            path="/dailyattendancelist/view/employeehours/:id/:shop"
            element={
              token && (type === "admin" || type === "branch_oic") ? (
                <EmployeeHours />
              ) : (
                <Navigate to="/" />
              )
            }
          />
          <Route
            path="/employeehours"
            element={
              token && (type === "admin" || type === "branch_oic") ? (
                <EmployeeHours />
              ) : (
                <Navigate to="/" />
              )
            }
          />
          <Route
            path="/attendance/:type"
            element={
              token && (type === "admin" || type === "branch_oic") ? (
                <AttendanceForm add />
              ) : (
                <Navigate to="/" />
              )
            }
          />
          <Route
            path="/attendance/:type/:id"
            element={
              token && (type === "admin" || type === "branch_oic") ? (
                <AttendanceForm edit />
              ) : (
                <Navigate to="/" />
              )
            }
          />
          <Route
            path="/supplier-price-report"
            element={
              token &&
              (type === "admin" ||
                type === "account_officer" ||
                type === "collection_officer") ? (
                <SupplierPriceReport />
              ) : (
                <Navigate to="/" />
              )
            }
          />
          <Route
            path="/storedeposit"
            element={
              token &&
              (type === "admin" ||
                type === "account_officer" ||
                type === "collection_officer" ||
                type === "branch_oic") ? (
                <StoreDeposit />
              ) : (
                <Navigate to="/" />
              )
            }
          />
          <Route
            path="/storedeposit/add"
            element={
              token &&
              (type === "admin" ||
                type === "account_officer" ||
                type === "collection_officer" ||
                type === "branch_oic") ? (
                <StoreDepositForm add />
              ) : (
                <Navigate to="/" />
              )
            }
          />
          <Route
            path="/dailycashcount"
            element={
              token &&
              (type === "admin" ||
                type === "account_officer" ||
                type === "collection_officer" ||
                type === "branch_oic") ? (
                <DailyCashCounts />
              ) : (
                <Navigate to="/" />
              )
            }
          />
          <Route
            path="/dailycashcount/shift/:id"
            element={
              token &&
              (type === "admin" ||
                type === "account_officer" ||
                type === "collection_officer" ||
                type === "branch_oic") ? (
                <ViewCashCountByShift />
              ) : (
                <Navigate to="/" />
              )
            }
          />
          <Route
            path="/dailycashcount/view/:id"
            element={
              token &&
              (type === "admin" ||
                type === "account_officer" ||
                type === "collection_officer" ||
                type === "branch_oic") ? (
                <ViewDailyCashCount />
              ) : (
                <Navigate to="/" />
              )
            }
          />
          <Route
            path="/dailyusage"
            element={
              token &&
              (type === "admin" ||
                type === "purchasing_officer" ||
                type === "warehouse_manager" ||
                type === "warehouse_assistant" ||
                type === "wholesale_head" ||
                type === "wholesale_assistant" ||
                type === "branch_oic" ||
                type === "branch_inventory_officer") ? (
                <DailyUsage />
              ) : (
                <Navigate to="/" />
              )
            }
          />
          <Route
            path="/dailyexpenses"
            element={
              token &&
              (type === "admin" ||
                type === "account_officer" ||
                type === "purchasing_officer" ||
                type === "collection_officer" ||
                type === "branch_oic" ||
                type === "branch_inventory_officer") ? (
                <DailyExpenses />
              ) : (
                <Navigate to="/" />
              )
            }
          />
          <Route
            path="/dailyexpenses/add"
            element={
              token &&
              (type === "admin" ||
                type === "account_officer" ||
                type === "purchasing_officer" ||
                type === "collection_officer" ||
                type === "branch_oic" ||
                type === "branch_inventory_officer") ? (
                <ExpensesForm add />
              ) : (
                <Navigate to="/" />
              )
            }
          />
          <Route
            path="/dailyexpenses/edit/:id"
            element={
              token &&
              (type === "admin" ||
                type === "account_officer" ||
                type === "purchasing_officer" ||
                type === "collection_officer" ||
                type === "branch_oic" ||
                type === "branch_inventory_officer") ? (
                <ExpensesForm edit />
              ) : (
                <Navigate to="/" />
              )
            }
          />
          <Route
            path="/dailyexpenses/view/:id"
            element={
              token &&
              (type === "admin" ||
                type === "account_officer" ||
                type === "purchasing_officer" ||
                type === "collection_officer" ||
                type === "branch_oic" ||
                type === "branch_inventory_officer") ? (
                <ViewDailyExpenses />
              ) : (
                <Navigate to="/" />
              )
            }
          />
          <Route
            path="/dailyexpenses/print/:id"
            element={
              token &&
              (type === "admin" ||
                type === "account_officer" ||
                type === "purchasing_officer" ||
                type === "collection_officer" ||
                type === "branch_oic" ||
                type === "branch_inventory_officer") ? (
                <PrintDailyExpenses />
              ) : (
                <Navigate to="/" />
              )
            }
          />
          <Route
            path="/dailysales"
            element={
              token &&
              (type === "admin" ||
                type === "account_officer" ||
                type === "collection_officer" ||
                type === "branch_oic") ? (
                <DailySales />
              ) : (
                <Navigate to="/" />
              )
            }
          />
          <Route
            path="/dailysales/undeposited"
            element={
              token &&
              (type === "admin" ||
                type === "account_officer" ||
                type === "collection_officer" ||
                type === "branch_oic") ? (
                <DailySales undeposited />
              ) : (
                <Navigate to="/" />
              )
            }
          />
          <Route
            path="/dailysales/view/:id/:date"
            // path="/dailysales/view/"
            element={
              token &&
              (type === "admin" ||
                type === "account_officer" ||
                type === "collection_officer" ||
                type === "branch_oic") ? (
                <ViewDailySales />
              ) : (
                <Navigate to="/" />
              )
            }
          />
          <Route
            path="/dailysales/print/:id"
            element={
              token &&
              (type === "admin" ||
                type === "account_officer" ||
                type === "collection_officer" ||
                type === "branch_oic") ? (
                <PrintDailySales />
              ) : (
                <Navigate to="/" />
              )
            }
          />
          <Route
            path="/deductions/:id/:branch_name/:date"
            element={
              token &&
              (type === "admin" ||
                type === "accounts_officer" ||
                type === "purchasing_officer" ||
                type === "hr_officer" ||
                type === "purchasing_staff" ||
                type === "operations_manager" ||
                type === "fielder_officer_1" ||
                type === "fielder_officer_2") ? (
                <EmployeeDeductions />
              ) : (
                <Navigate to="/" />
              )
            }
          />
          <Route
            path="/dailywastage"
            element={
              token &&
              (type === "admin" ||
                type === "account_officer" ||
                type === "purchasing_officer" ||
                type === "collection_officer" ||
                type === "branch_oic" ||
                type === "branch_inventory_officer") ? (
                <DailyWastage />
              ) : (
                <Navigate to="/" />
              )
            }
          />
          <Route
            path="/dailywastage/view/:id"
            element={
              token &&
              (type === "admin" ||
                type === "account_officer" ||
                type === "purchasing_officer" ||
                type === "collection_officer" ||
                type === "branch_inventory_officer") ? (
                <ViewDailyWastage />
              ) : (
                <Navigate to="/" />
              )
            }
          />
          <Route
            path="/wastagereports"
            element={
              token &&
              (type === "admin" ||
                type === "account_officer" ||
                type === "purchasing_officer" ||
                type === "collection_officer" ||
                type === "branch_oic" ||
                type === "branch_inventory_officer") ? (
                <WastageReports />
              ) : (
                <Navigate to="/" />
              )
            }
          />
          <Route
            path="/customerpaymentreports"
            element={
              token &&
              (type === "admin" ||
                type === "accounts_officer" ||
                type === "operations_manager" ||
                type === "fielder_officer_1" ||
                type === "fielder_officer_2") ? (
                <CustomerPaymentsReports />
              ) : (
                <Navigate to="/" />
              )
            }
          />
          <Route
            path="/dailyorders"
            element={
              token &&
              (type === "admin" ||
                type === "account_officer" ||
                type === "collection_officer" ||
                type === "branch_oic") ? (
                <DailyOrders />
              ) : (
                <Navigate to="/" />
              )
            }
          />
          <Route
            path="/dailyorders/branch/:id/:priceLevelId/:date"
            element={
              token &&
              (type === "admin" ||
                type === "account_officer" ||
                type === "collection_officer" ||
                type === "branch_oic") ? (
                <BranchDailyOrders />
              ) : (
                <Navigate to="/" />
              )
            }
          />
          <Route
            path="/dailyorders/branch/:id/:priceLevelId/:date/addorder"
            element={
              token &&
              (type === "admin" ||
                type === "account_officer" ||
                type === "collection_officer" ||
                type === "branch_oic") ? (
                <AddOrder />
              ) : (
                <Navigate to="/" />
              )
            }
          />
          {/* <Route
                        path="/storedeposit"
                        element={
                            token &&
                            (type === "admin" ||
                                type === "supervisor" ||
                                type === "accounts_officer" ||
                                type === "purchasing_officer" ||
                                type === "purchasing_staff" ||
                                // type === "hr_officer" ||
                                type === "operations_manager" ||
                                type === "fielder_officer_1" ||
                                type === "fielder_officer_2") ? (
                                <StoreDeposit />
                            ) : (
                                <Navigate to="/" />
                            )
                        }
                    /> */}

          {/* -------------------------------------------------- */}
          {/* OFFICE REPORTS */}
          <Route
            path="/payables"
            element={
              token &&
              (type === "admin" ||
                // type === "hr_officer" ||
                type === "purchasing_officer") ? (
                <Payables />
              ) : (
                <Navigate to="/" />
              )
            }
          />
          <Route
            path="/totalsales"
            element={
              token && type === "admin" ? <TotalSales /> : <Navigate to="/" />
            }
          />
          <Route
            path="/franchiseesalesreport"
            element={
              token && type === "admin" ? (
                <FranchiseeSalesReport />
              ) : (
                <Navigate to="/" />
              )
            }
          />
          <Route
            path="/salesbyitem"
            element={
              token && type === "admin" ? <SalesByItem /> : <Navigate to="/" />
            }
          />
          <Route
            path="/listofstores"
            element={
              token && (type === "admin" || type === "branch_oic") ? (
                <ListOfStores />
              ) : (
                <Navigate to="/" />
              )
            }
          />
          <Route
            path="/peakhours"
            element={
              token && (type === "admin" || type === "branch_oic") ? (
                <PeakHours />
              ) : (
                <Navigate to="/" />
              )
            }
          />
          <Route
            path="/listofbranches"
            element={
              token && type === "admin" ? (
                <ListOfBranches />
              ) : (
                <Navigate to="/" />
              )
            }
          />
          <Route
            path="/purchaseditems"
            element={
              token && type === "admin" ? (
                <PurchasedItemsSummary />
              ) : (
                <Navigate to="/" />
              )
            }
          />
          <Route
            path="/transferhistory"
            element={
              token &&
              (type === "admin" ||
                type === "warehouse_manager" ||
                type === "warehouse_assistant" ||
                type === "branch_oic" ||
                type === "branch_inventory_officer") ? (
                <TransferHistory />
              ) : (
                <Navigate to="/" />
              )
            }
          />
          <Route
            path="/transferhistory/view/:id"
            element={
              token &&
              (type === "admin" ||
                type === "warehouse_manager" ||
                type === "warehouse_assistant" ||
                type === "branch_oic" ||
                type === "branch_inventory_officer") ? (
                <ViewTransferHistory />
              ) : (
                <Navigate to="/" />
              )
            }
          />

          <Route
            path="/retail-top-selling-item"
            element={
              token && (type === "admin" || type === "branch_oic") ? (
                <RetailTopSellingPrice />
              ) : (
                <Navigate to="/" />
              )
            }
          />

          <Route
            path="/wholesale-top-selling-item"
            element={
              token && type === "admin" ? (
                // || type === "purchasing_staff"
                <WholesaleTopSellingPrice />
              ) : (
                <Navigate to="/" />
              )
            }
          />

          <Route
            path="/salesperproduct"
            element={
              token && (type === "admin" || type === "branch_oic") ? (
                <SalesPerProduct />
              ) : (
                <Navigate to="/" />
              )
            }
          />

          <Route
            path="/storediscountreport"
            element={
              token && (type === "admin" || type === "branch_oic") ? (
                <StoreDiscountReport />
              ) : (
                <Navigate to="/" />
              )
            }
          />

          <Route
            path="/totalsalesreport"
            element={
              token && type === "admin" ? (
                // || type === "purchasing_staff"
                <TotalSalesReport />
              ) : (
                <Navigate to="/" />
              )
            }
          />
          {/* -------------------------------------------------- */}
          {/* MANAGE */}
          <Route
            path="/suppliers"
            element={
              token && (type === "admin" || type === "purchasing_officer") ? (
                <Suppliers />
              ) : (
                <Navigate to="/" />
              )
            }
          />
          {/* <Route
                        path="/vendors"
                        element={
                            token &&
                            (type === "admin" ||
                                type === "hr_officer" ||
                                type === "purchasing_officer") ? (
                                <Vendors />
                            ) : (
                                <Navigate to="/" />
                            )
                        }
                    /> */}
          <Route
            path="/banks"
            element={
              token && type === "admin" ? <Banks /> : <Navigate to="/" />
            }
          />
          <Route
            path="/terminals"
            element={
              token && type === "admin" ? <Terminals /> : <Navigate to="/" />
            }
          />
          <Route
            path="/items"
            element={
              token &&
              (type === "admin" ||
                type === "bidding_officer" ||
                type === "purchasing_officer" ||
                type === "warehouse_manager" ||
                type === "warehouse_assistant") ? (
                <Items />
              ) : (
                <Navigate to="/" />
              )
            }
          />
          <Route
            path="/discounts"
            element={
              token &&
              (type === "admin" ||
                // type === "hr_officer" ||
                type === "purchasing_officer") ? (
                <Discounts />
              ) : (
                <Navigate to="/" />
              )
            }
          />
          <Route
            path="/discounts/add/:type"
            element={
              token &&
              (type === "admin" ||
                // type === "hr_officer" ||
                type === "purchasing_officer") ? (
                <FormDiscounts add />
              ) : (
                <Navigate to="/" />
              )
            }
          />
          <Route
            path="/discounts/edit/:type/:id"
            element={
              token &&
              (type === "admin" ||
                // type === "hr_officer" ||
                type === "purchasing_officer") ? (
                <FormDiscounts edit />
              ) : (
                <Navigate to="/" />
              )
            }
          />
          <Route
            path="/discounts/view/:type/:id"
            element={
              token &&
              (type === "admin" ||
                // type === "hr_officer" ||
                type === "purchasing_officer") ? (
                <ViewDiscounts />
              ) : (
                <Navigate to="/" />
              )
            }
          />
          <Route
            path="/branches"
            element={
              token &&
              (type === "admin" ||
                type === "branch_oic" ||
                type === "branch_inventory_officer") ? (
                <Branches />
              ) : (
                <Navigate to="/" />
              )
            }
          />
          <Route
            path="/warehouses"
            element={
              token &&
              (type === "admin" ||
                // type === "hr_officer" ||
                type === "purchasing_officer" ||
                type === "franchise_officer") ? (
                <Warehouses />
              ) : (
                <Navigate to="/" />
              )
            }
          />
          {/* <Route
                        path="/branchgroup"
                        element={
                            token &&
                            (type === "admin" ||
                                type === "supervisor" ||
                                type === "purchasing_officer" ||
                                type === "operations_manager" ||
                                type === "franchise_officer") ? (
                                <BranchGroup />
                            ) : (
                                <Navigate to="/" />
                            )
                        }
                    />  */}
          <Route
            path="/category"
            element={
              token &&
              (type === "admin" ||
                // type === "hr_officer" ||
                type === "purchasing_officer" ||
                type === "franchise_officer") ? (
                <Category />
              ) : (
                <Navigate to="/" />
              )
            }
          />
          <Route
            path="/category/add"
            element={
              token &&
              (type === "admin" ||
                // type === "hr_officer" ||
                type === "purchasing_officer" ||
                type === "franchise_officer") ? (
                // <NestedCategoryForm/>
                <FormCategory2 />
              ) : (
                <Navigate to="/" />
              )
            }
          />
          <Route
            path="/category/add2"
            element={
              token &&
              (type === "admin" ||
                // type === "hr_officer" ||
                type === "purchasing_officer" ||
                type === "franchise_officer") ? (
                <NestedCategoryForm2 />
              ) : (
                // <FormCategory add/>
                <Navigate to="/" />
              )
            }
          />
          <Route
            path="/category/edit/:id"
            element={
              token &&
              (type === "admin" ||
                // type === "hr_officer" ||
                type === "purchasing_officer" ||
                type === "franchise_officer") ? (
                <FormCategory edit />
              ) : (
                <Navigate to="/" />
              )
            }
          />
          <Route
            path="/category/add"
            element={
              token &&
              (type === "admin" ||
                // type === "hr_officer" ||
                type === "purchasing_officer" ||
                type === "franchise_officer") ? (
                <Category />
              ) : (
                <Navigate to="/" />
              )
            }
          />
          <Route
            path="/inventorylevel"
            element={
              token &&
              (type === "admin" ||
                // type === "hr_officer" ||
                type === "purchasing_officer" ||
                type === "franchise_officer") ? (
                <InventoryLevel />
              ) : (
                <Navigate to="/" />
              )
            }
          />
          <Route
            path="/inventorylevel/add"
            element={
              token &&
              (type === "admin" ||
                // type === "hr_officer" ||
                type === "purchasing_officer" ||
                type === "franchise_officer") ? (
                <FormInventoryLevel add />
              ) : (
                <Navigate to="/" />
              )
            }
          />
          <Route
            path="/inventorylevel/edit/:id"
            element={
              token &&
              (type === "admin" ||
                // type === "hr_officer" ||
                type === "purchasing_officer" ||
                type === "franchise_officer") ? (
                <FormInventoryLevel edit />
              ) : (
                <Navigate to="/" />
              )
            }
          />
          <Route
            path="/products"
            element={
              token &&
              (type === "admin" ||
                // type === "hr_officer" ||
                type === "purchasing_officer") ? (
                <Products />
              ) : (
                <Navigate to="/" />
              )
            }
          />
          <Route
            path="/products/updatepriority/:shop"
            element={
              token &&
              (type === "admin" ||
                // type === "hr_officer" ||
                type === "purchasing_officer") ? (
                <ProductPriority />
              ) : (
                <Navigate to="/" />
              )
            }
          />
          <Route
            path="/itemprices"
            element={
              token &&
              (type === "admin" ||
                type === "bidding_officer" ||
                type === "warehouse_manager") ? (
                <ItemPricesV2 />
              ) : (
                // <ItemPrices />
                <Navigate to="/" />
              )
            }
          />
          <Route
            path="/dsritems"
            element={
              token &&
              (type === "admin" ||
                // type === "hr_officer" ||
                type === "purchasing_officer") ? (
                <DsrItems />
              ) : (
                <Navigate to="/" />
              )
            }
          />
          <Route
            path="/pricelevels"
            element={
              token && (type === "admin" || type === "warehouse_manager") ? (
                <PriceLevels />
              ) : (
                <Navigate to="/" />
              )
            }
          />
          <Route
            path="/pricelevels/add"
            element={
              token && (type === "admin" || type === "warehouse_manager") ? (
                <AddPriceLevel />
              ) : (
                <Navigate to="/" />
              )
            }
          />
          <Route
            path="/pricelevels/edit/:id"
            element={
              token && (type === "admin" || type === "warehouse_manager") ? (
                <EditPriceLevel />
              ) : (
                <Navigate to="/" />
              )
            }
          />
          <Route
            path="/pricelevels/view/:id"
            element={
              token && (type === "admin" || type === "warehouse_manager") ? (
                <ViewPriceLevel />
              ) : (
                <Navigate to="/" />
              )
            }
          />
          <Route
            path="/users"
            element={
              token &&
              (type === "admin" ||
                type === "purchasing_officer" ||
                type === "hr_officer") ? (
                <Users />
              ) : (
                <Navigate to="/" />
              )
            }
          />
          <Route
            path="/forwarders"
            element={
              token &&
              (type === "admin" ||
                // type === "hr_officer" ||
                type === "purchasing_officer") ? (
                <Forwarders />
              ) : (
                <Navigate to="/" />
              )
            }
          />
          <Route
            path="/departments"
            element={
              token &&
              (type === "admin" ||
                // type === "hr_officer" ||
                type === "purchasing_officer") ? (
                <Departments />
              ) : (
                <Navigate to="/" />
              )
            }
          />
          <Route
            path="/customers"
            element={
              token &&
              (type === "admin" ||
                type === "bidding_officer" ||
                type === "wholesale_head" ||
                type === "wholesale_assistant") ? (
                <Customers />
              ) : (
                <Navigate to="/" />
              )
            }
          />

          {/* EMPLOYEES  */}
          <Route
            path="/employees"
            element={
              token &&
              (type === "admin" ||
                type === "hr_officer" ||
                type === "purchasing_staff") ? (
                <Employees />
              ) : (
                <Navigate to="/" />
              )
            }
          />
          <Route
            path="/cashadvance"
            element={
              token &&
              (type === "admin" ||
                type === "hr_officer" ||
                type === "purchasing_staff") ? (
                <CashAdvance />
              ) : (
                <Navigate to="/" />
              )
            }
          />
          <Route
            path="/cashadvance/add/:type"
            element={
              token &&
              (type === "admin" ||
                type === "hr_officer" ||
                type === "purchasing_staff") ? (
                <FormCashAdvance add />
              ) : (
                <Navigate to="/" />
              )
            }
          />
          <Route
            path="/cashadvance/edit/:id/:type"
            element={
              token &&
              (type === "admin" ||
                type === "hr_officer" ||
                type === "purchasing_staff") ? (
                <FormCashAdvance edit />
              ) : (
                <Navigate to="/" />
              )
            }
          />
          <Route
            path="/cashadvance/view/:id/:type/:ca_type"
            element={
              token &&
              (type === "admin" ||
                type === "hr_officer" ||
                type === "purchasing_staff") ? (
                <ReviewCashAdvance />
              ) : (
                <Navigate to="/" />
              )
            }
          />
          <Route
            path="/payroll"
            element={
              token &&
              (type === "admin" ||
                type === "hr_officer" ||
                type === "purchasing_staff") ? (
                <Payroll />
              ) : (
                <Navigate to="/" />
              )
            }
          />
          <Route
            path="/payrollmultiple"
            element={
              token &&
              (type === "admin" ||
                type === "hr_officer" ||
                type === "purchasing_staff") ? (
                <MultiplePayroll />
              ) : (
                <Navigate to="/" />
              )
            }
          />
          <Route
            path="/payroll/add/:id"
            element={
              token &&
              (type === "admin" ||
                type === "hr_officer" ||
                type === "purchasing_staff") ? (
                <FormPayroll add />
              ) : (
                <Navigate to="/" />
              )
            }
          />
          <Route
            path="/payroll/add/multiple"
            element={
              token &&
              (type === "admin" ||
                type === "hr_officer" ||
                type === "purchasing_staff") ? (
                <MultipleFormPayroll add />
              ) : (
                <Navigate to="/" />
              )
            }
          />
          <Route
            path="/payroll/edit/:id"
            element={
              token &&
              (type === "admin" ||
                type === "hr_officer" ||
                type === "purchasing_staff") ? (
                <FormPayroll edit />
              ) : (
                <Navigate to="/" />
              )
            }
          />
          <Route
            path="/payroll/view/:id"
            element={
              token &&
              (type === "admin" ||
                type === "hr_officer" ||
                type === "purchasing_staff") ? (
                <ViewPayroll view />
              ) : (
                <Navigate to="/" />
              )
            }
          />
          <Route
            path="/payrollreport"
            element={
              token &&
              (type === "admin" ||
                type === "hr_officer" ||
                type === "purchasing_staff") ? (
                <PayrollReport />
              ) : (
                <Navigate to="/" />
              )
            }
          />
          <Route
            path="/scheduler"
            element={
              token &&
              (type === "admin" ||
                type === "hr_officer" ||
                type === "operations_manager" ||
                type === "purchasing_staff") ? (
                <EmployeeScheduler />
              ) : (
                <Navigate to="/" />
              )
            }
          />
          <Route
            path="/scheduler/upload"
            element={
              token &&
              (type === "admin" ||
                type === "hr_officer" ||
                type === "operations_manager" ||
                type === "purchasing_staff") ? (
                <UploadSchedule />
              ) : (
                <Navigate to="/" />
              )
            }
          />
          <Route
            path="/scheduler/add/:type"
            element={
              token &&
              (type === "admin" ||
                type === "hr_officer" ||
                type === "operations_manager" ||
                type === "purchasing_staff") ? (
                <FormSchedule add />
              ) : (
                <Navigate to="/" />
              )
            }
          />
          <Route
            path="/scheduler/edit/:type/:id"
            element={
              token &&
              (type === "admin" ||
                type === "hr_officer" ||
                type === "operations_manager" ||
                type === "purchasing_staff") ? (
                <FormSchedule edit />
              ) : (
                <Navigate to="/" />
              )
            }
          />
          <Route
            path="/overtimereport"
            element={
              token && (type === "admin" || type === "hr_officer") ? (
                <OvertimeReport />
              ) : (
                <Navigate to="/" />
              )
            }
          />
          <Route
            path="/undertimereport"
            element={
              token && (type === "admin" || type === "hr_officer") ? (
                <UndertimeReport />
              ) : (
                <Navigate to="/" />
              )
            }
          />
          <Route
            path="/unfollowedbreakreport"
            element={
              token && (type === "admin" || type === "hr_officer") ? (
                <UnfollowedBreakReport />
              ) : (
                <Navigate to="/" />
              )
            }
          />
          <Route
            path="/holiday"
            element={
              token &&
              (type === "admin" ||
                type === "hr_officer" ||
                type === "purchasing_staff") ? (
                <Holiday />
              ) : (
                <Navigate to="/" />
              )
            }
          />

          {/* PETTY CASH */}
          <Route
            path="/pettycash"
            element={
              token &&
              (type === "admin" ||
                // type === "hr_officer" ||
                type === "purchasing_officer" ||
                type === "office_staff") ? (
                <PettyCash />
              ) : (
                <Navigate to="/" />
              )
            }
          />
          <Route
            path="/pettycash/cashin"
            element={
              token &&
              (type === "admin" ||
                // type === "hr_officer" ||
                type === "purchasing_officer" ||
                type === "office_staff") ? (
                <PettyCashCashInForm add />
              ) : (
                <Navigate to="/" />
              )
            }
          />
          <Route
            path="/pettycash/cashin/:id/edit"
            element={
              token && (type === "admin" || type === "office_staff") ? (
                <PettyCashCashInForm edit />
              ) : (
                <Navigate to="/" />
              )
            }
          />
          <Route
            path="/pettycash/cashin/:id"
            element={
              token && (type === "admin" || type === "office_staff") ? (
                <PettyCashCashInView />
              ) : (
                <Navigate to="/" />
              )
            }
          />
          <Route
            path="/pettycash/cashout"
            element={
              token &&
              (type === "admin" ||
                // type === "hr_officer" ||
                type === "purchasing_officer" ||
                type === "office_staff") ? (
                <PettyCashCashOutForm add />
              ) : (
                <Navigate to="/" />
              )
            }
          />
          <Route
            path="/pettycash/cashout/:id/edit"
            element={
              token && (type === "admin" || type === "office_staff") ? (
                <PettyCashCashOutForm edit />
              ) : (
                <Navigate to="/" />
              )
            }
          />
          <Route
            path="/pettycash/cashout/:id"
            element={
              token && (type === "admin" || type === "office_staff") ? (
                <PettyCashCashOutView />
              ) : (
                <Navigate to="/" />
              )
            }
          />
          <Route
            path="/audittrailsreport"
            element={
              token && (type === "admin" || type === "office_staff") ? (
                <AuditTrails />
              ) : (
                <Navigate to="/" />
              )
            }
          />
          <Route
            path="/ejournalreport"
            element={
              token && (type === "admin" || type === "office_staff") ? (
                <Ejournal />
              ) : (
                <Navigate to="/" />
              )
            }
          />
          <Route
            path="/xreadingreport"
            element={
              token && (type === "admin" || type === "office_staff") ? (
                <XReading />
              ) : (
                <Navigate to="/" />
              )
            }
          />
          <Route
            path="/zreadingreport"
            element={
              token && (type === "admin" || type === "office_staff") ? (
                <ZReading />
              ) : (
                <Navigate to="/" />
              )
            }
          />
        </Routes>
      </Router>
    </div>
  )
}

export default App
